import { CatalogScannerScreen } from './catalog-scanner-screen';
import { LocalScannerContextProvider } from '@/contexts/local-scanner-context';
import { LocalScannerScreen } from './local-scanner-screen';
import { ScannerContextProvider } from '@/contexts/scanner-context';
import { useSupplierDynamicConfigFlag } from '@/hooks/use-dynamic-config-value';

export const CatalogScanner: React.FC = () => {
  const localScanUXEnabled = useSupplierDynamicConfigFlag(
    'on_device_scanning_config',
    'local_scan_ux_enabled',
  );

  return (
    <ScannerContextProvider>
      {localScanUXEnabled ? (
        <LocalScannerContextProvider>
          <LocalScannerScreen />
        </LocalScannerContextProvider>
      ) : (
        <CatalogScannerScreen />
      )}
    </ScannerContextProvider>
  );
};
